import { render, staticRenderFns } from "./featured-store.vue?vue&type=template&id=49f00942&scoped=true&"
import script from "./featured-store.vue?vue&type=script&lang=js&"
export * from "./featured-store.vue?vue&type=script&lang=js&"
import style0 from "./featured-store.vue?vue&type=style&index=0&id=49f00942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f00942",
  null
  
)

export default component.exports